const root = 'confirmDialog'

export const TestId = {
  root,
  title: `${root}-title`,
  message: `${root}-message`,
  cancelButton: `${root}-cancelButton`,
  okButton: `${root}-okButton`,
}
